export class BasketApiError extends Error {
    status;
    code;
    constructor(status, code) {
        super(code);
        this.status = status;
        this.code = code;
    }
}
export class BasketApiClient {
    baseUrl;
    authToken;
    constructor(baseUrl = "", authToken) {
        this.baseUrl = baseUrl;
        this.authToken = authToken;
    }
    async request(path, init = {}) {
        const response = await fetch(`${this.baseUrl}${path}`, {
            ...init,
            credentials: "include",
            headers: {
                ...(init.body ? { "content-type": "application/json" } : {}),
                ...(this.authToken ? { authorization: `Bearer ${this.authToken}` } : {}),
                ...init.headers,
            },
        });
        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new BasketApiError(response.status, body.error ?? `http_${response.status}`);
        }
        return response.json();
    }
    bootstrap() { return this.request("/api/bootstrap"); }
    openThread(agent, surface, meetingSessionId) { return this.request("/api/threads/open", { method: "POST", body: JSON.stringify({ agent, surface, ...(meetingSessionId ? { meetingSessionId } : {}) }) }); }
    threads(limit = 30) { return this.request(`/api/threads?limit=${limit}`); }
    thread(id) { return this.request(`/api/threads/${encodeURIComponent(id)}`); }
    appendTurn(id, turn) { return this.request(`/api/threads/${encodeURIComponent(id)}/turns`, { method: "POST", body: JSON.stringify(turn) }); }
    closeThread(id) { return this.request(`/api/threads/${encodeURIComponent(id)}/close`, { method: "POST", body: "{}" }); }
    openMeetingSession(opaqueMeetingKey, context) {
        return this.request("/api/meet/sessions/open", { method: "POST", body: JSON.stringify({ opaqueMeetingKey, context }) });
    }
    updateMeetingSession(id, context) {
        return this.request(`/api/meet/sessions/${encodeURIComponent(id)}/context`, { method: "POST", body: JSON.stringify({ context }) });
    }
    endMeetingSession(id) {
        return this.request(`/api/meet/sessions/${encodeURIComponent(id)}/end`, { method: "POST", body: "{}" });
    }
    settings() { return this.request("/api/settings"); }
    updateSettings(value) { return this.request("/api/settings", { method: "PUT", body: JSON.stringify(value) }); }
    usage(period) { return this.request(`/api/usage/summary?period=${period}`); }
    devices() { return this.request("/api/devices"); }
    revokeDevice(deviceId) { return this.request(`/api/devices/${encodeURIComponent(deviceId)}`, { method: "DELETE" }); }
    logout() { return this.request("/auth/logout", { method: "POST", body: "{}" }); }
    logoutAll() { return this.request("/api/logout-all", { method: "POST", body: "{}" }); }
}
export class IdleLifecycle {
    onState;
    warningMs;
    endMs;
    warningTimer;
    endTimer;
    constructor(onState, warningMs = 270_000, endMs = 300_000) {
        this.onState = onState;
        this.warningMs = warningMs;
        this.endMs = endMs;
    }
    start() { this.activity(); }
    activity() {
        this.stop();
        this.onState("active");
        this.warningTimer = setTimeout(() => this.onState("warning"), this.warningMs);
        this.endTimer = setTimeout(() => this.onState("ended"), this.endMs);
    }
    stop() {
        if (this.warningTimer)
            clearTimeout(this.warningTimer);
        if (this.endTimer)
            clearTimeout(this.endTimer);
        this.warningTimer = undefined;
        this.endTimer = undefined;
    }
}
//# sourceMappingURL=index.js.map